import React, { useMemo } from "react";
import style from "./index.module.scss";
import TipStuList from "../TipStuList";
import { BaseQuestionType, EndExerciseOptionModel } from "service/exercise";
import { indexToChar } from "utils/common";
import { useAtomValue } from "jotai";
import { staticsAtom } from "service/stores/Exercise/Statics";

interface ExerciseStaticsOptionProps {
    queTypeId: number;
    index: number;
    data: EndExerciseOptionModel;
}

export default function ExerciseStaticsOption({
    queTypeId,
    index,
    data
}: ExerciseStaticsOptionProps) {
    const { stuCount } = useAtomValue(staticsAtom);

    const percent = useMemo(() => {
        if (!stuCount) return 0;
        return `${((data.stuOptionInfos?.length || 0) * 100) / stuCount}%`;
    }, [stuCount, data.stuOptionInfos?.length]);

    return (
        <div className={style.root}>
            <div className={style.main}>
                <em className={style.index}>
                    {queTypeId === BaseQuestionType.Fill
                        ? `(${index + 1})`
                        : indexToChar(index)}
                    .
                </em>
                <div
                    className={style.description}
                    dangerouslySetInnerHTML={{ __html: data.description }}
                />
            </div>

            <div className={style.percent}>
                <div className={style.inner} style={{ width: percent }} />

                <TipStuList stuList={data.stuOptionInfos || []}>
                    <div className={style.count}>
                        {data.stuOptionInfos?.length || 0}人
                    </div>
                </TipStuList>
            </div>
        </div>
    );
}
